import Routes from '@/utils/routes';

export const IntelligenceRoute = {
	path: '/insights',
	name: Routes.Intelligence,
	component: () => import('./IntelView'),
};
